import React from "react";
import CommentsFieldProto from "./comments-proto";

export default function renderCommentsInList(props) {
    return <CommentsFieldProto renderMode="list" {...props} />;
}